import { render, staticRenderFns } from "./IconSvgSnmmiDirectory.vue?vue&type=template&id=0216f5f2&scoped=true&"
import script from "./IconSvgSnmmiDirectory.vue?vue&type=script&lang=js&"
export * from "./IconSvgSnmmiDirectory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0216f5f2",
  null
  
)

export default component.exports